//init
import * as Realm from 'realm-web';
const app = new Realm.App({ id: process.env.REACT_APP_MNDB_RELM_TRXN});


export const AuthCodeTrxn = async () => {
  const cred = Realm.Credentials.apiKey(process.env.REACT_APP_MNDB_AUTH_TRXN);
  const user = await app.logIn(cred);
  return user
}

// ------------------------ //
export const CreateToken = async (item) => {
  const trxnuser = await AuthCodeTrxn()
  const result = await trxnuser.functions.toknCreateToken(JSON.stringify({
    ...item, 
    webb: process.env.REACT_APP_WEBB_SITE_NMBR
  }));
  // console.log(result)
  return JSON.parse(result);
}
